import { render, staticRenderFns } from "./NewTransaction.vue?vue&type=template&id=2b4b3b5b&scoped=true"
import script from "./NewTransaction.vue?vue&type=script&lang=js"
export * from "./NewTransaction.vue?vue&type=script&lang=js"
import style0 from "./NewTransaction.vue?vue&type=style&index=0&id=2b4b3b5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b3b5b",
  null
  
)

export default component.exports